// import React from 'react';
// import styled from 'styled-components';

// const PageContainer = styled.div`
//     padding: 100px 20px;
//     max-width: 1200px;
//     margin: 0 auto;
// `;

// const HeroSection = styled.section`
//     text-align: center;
//     margin-bottom: 60px;
// `;

// const Title = styled.h1`
//     font-size: 3rem;
//     color: #333;
//     margin-bottom: 20px;
// `;

// const Subtitle = styled.p`
//     font-size: 1.2rem;
//     color: #666;
//     max-width: 800px;
//     margin: 0 auto;
// `;

// const ServicesGrid = styled.div`
//     display: grid;
//     grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
//     gap: 30px;
//     margin-top: 40px;
// `;

// const ServiceCard = styled.div`
//     background: #fff;
//     padding: 30px;
//     border-radius: 10px;
//     box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
//     transition: transform 0.3s ease;

//     &:hover {
//         transform: translateY(-5px);
//     }
// `;

// const ServiceIcon = styled.div`
//     font-size: 2.5rem;
//     color: #1a2a6c;
//     margin-bottom: 20px;
// `;

// const ServiceTitle = styled.h2`
//     color: #1a2a6c;
//     margin-bottom: 15px;
//     font-size: 1.5rem;
// `;

// const ServiceDescription = styled.p`
//     color: #666;
//     line-height: 1.6;
// `;

// const Services = () => {
//     return (
//         <PageContainer>
//             <HeroSection>
//                 <Title>Our Products</Title>
//                 <Subtitle>
//                     We offer a comprehensive range of IT services to help your business
//                     thrive in the digital age.
//                 </Subtitle>
//             </HeroSection>

//             <ServicesGrid>
//                 <ServiceCard>
//                     <ServiceIcon>💻</ServiceIcon>
//                     <ServiceTitle>Custom Software Development</ServiceTitle>
//                     <ServiceDescription>
//                         Tailored software solutions designed to meet your specific business
//                         needs and challenges.
//                     </ServiceDescription>
//                 </ServiceCard>

//                 <ServiceCard>
//                     <ServiceIcon>🌐</ServiceIcon>
//                     <ServiceTitle>Web Development</ServiceTitle>
//                     <ServiceDescription>
//                         Modern, responsive websites that engage users and drive business growth.
//                     </ServiceDescription>
//                 </ServiceCard>

//                 <ServiceCard>
//                     <ServiceIcon>📱</ServiceIcon>
//                     <ServiceTitle>Mobile App Development</ServiceTitle>
//                     <ServiceDescription>
//                         Native and cross-platform mobile applications for iOS and Android.
//                     </ServiceDescription>
//                 </ServiceCard>

//                 <ServiceCard>
//                     <ServiceIcon>☁️</ServiceIcon>
//                     <ServiceTitle>Cloud Solutions</ServiceTitle>
//                     <ServiceDescription>
//                         Scalable cloud infrastructure and services to power your digital
//                         transformation.
//                     </ServiceDescription>
//                 </ServiceCard>

//                 <ServiceCard>
//                     <ServiceIcon>🔄</ServiceIcon>
//                     <ServiceTitle>Digital Transformation</ServiceTitle>
//                     <ServiceDescription>
//                         Comprehensive strategies to modernize your business processes and
//                         operations.
//                     </ServiceDescription>
//                 </ServiceCard>

//                 <ServiceCard>
//                     <ServiceIcon>🔒</ServiceIcon>
//                     <ServiceTitle>IT Security</ServiceTitle>
//                     <ServiceDescription>
//                         Robust security solutions to protect your data and systems from
//                         threats.
//                     </ServiceDescription>
//                 </ServiceCard>
//             </ServicesGrid>
//         </PageContainer>
//     );
// };

// export default Services; 



import React from 'react';
import styled, { keyframes } from 'styled-components';
import { motion } from 'framer-motion';
import { 
  FaLaptopCode, 
  FaGlobe, 
  FaMobileAlt, 
  FaCloud, 
  FaSync, 
  FaShieldAlt,
  FaRocket,
  FaCogs,
  FaChartLine,
  FaUsers,
  FaDatabase,
  FaLightbulb
} from 'react-icons/fa';

// Animations
const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const gradientShift = keyframes`
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
`;

const float = keyframes`
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
`;

// Styled Components
const PageContainer = styled.div`
  padding: 120px 20px 80px;
  max-width: 1400px;
  margin: 0 auto;
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, #e2e8f0, transparent);
  }
`;

const HeroSection = styled(motion.section)`
  text-align: center;
  margin-bottom: 80px;
  padding: 60px 40px;
  background: linear-gradient(135deg, var(--theme-hero-start) 0%, var(--theme-hero-end) 50%, var(--theme-hero-start) 100%);
  border-radius: 24px;
  color: #FFFFFF;
  position: relative;
  overflow: hidden;
  box-shadow: 0 20px 40px var(--theme-shadow-accent);

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: 
      radial-gradient(circle at 20% 80%, rgba(120, 119, 198, 0.1) 0%, transparent 50%),
      radial-gradient(circle at 80% 20%, rgba(255, 200, 87, 0.1) 0%, transparent 50%);
    background-blend-mode: overlay;
  }

  @media (max-width: 768px) {
    padding: 40px 20px;
    margin-bottom: 60px;
  }
`;

const Title = styled.h1`
  font-size: clamp(2.5rem, 5vw, 4rem);
  font-weight: 800;
  margin-bottom: 20px;
  letter-spacing: -0.02em;
  position: relative;
  z-index: 2;
  
  span {
    display: block;
    font-size: clamp(1rem, 2vw, 1.5rem);
    color: #FFC857;
    margin-top: 1rem;
    font-weight: 600;
    letter-spacing: 0.3em;
    text-transform: uppercase;
    background: linear-gradient(135deg, #FFC857, #FF9F1C);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
`;

const Subtitle = styled.p`
  font-size: clamp(1.1rem, 2vw, 1.4rem);
  color: rgba(244, 244, 244, 0.95);
  max-width: 700px;
  margin: 0 auto;
  line-height: 1.6;
  font-weight: 300;
  position: relative;
  z-index: 2;
`;

const ServicesGrid = styled(motion.div)`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 40px;
  margin-top: 40px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 30px;
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    gap: 25px;
  }
`;

const ServiceCard = styled(motion.div)`
  background: #ffffff;
  padding: 50px 40px;
  border-radius: 20px;
  box-shadow: 
    0 10px 30px rgba(0, 0, 0, 0.08),
    0 0 0 1px rgba(0, 0, 0, 0.03);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  border-top: 4px solid var(--theme-accent);
  cursor: pointer;
  text-align: center;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, var(--theme-accent-soft), transparent);
    transition: left 0.6s ease;
  }

  &:hover {
    transform: translateY(-8px);
    box-shadow: 
      0 25px 50px -12px rgba(0, 0, 0, 0.15),
      0 0 0 1px rgba(0, 0, 0, 0.03);

    &::before {
      left: 100%;
    }

    .service-icon {
      transform: scale(1.1);
      color: var(--theme-accent);
      animation: ${float} 3s ease-in-out infinite;
    }

    .learn-more {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @media (max-width: 768px) {
    padding: 40px 30px;
  }

  @media (max-width: 480px) {
    padding: 35px 25px;
  }
`;

const ServiceIcon = styled.div`
  font-size: 4rem;
  color: var(--theme-primary);
  margin-bottom: 25px;
  transition: all 0.4s ease;
  display: flex;
  justify-content: center;

  @media (max-width: 480px) {
    font-size: 3.5rem;
  }
`;

const ServiceTitle = styled.h2`
  color: var(--theme-primary);
  margin-bottom: 20px;
  font-size: 1.6rem;
  font-weight: 700;
  line-height: 1.3;

  @media (max-width: 480px) {
    font-size: 1.4rem;
  }
`;

const ServiceDescription = styled.p`
  color: #64748b;
  line-height: 1.7;
  margin-bottom: 25px;
  font-size: 1.05rem;
  font-weight: 400;
`;

const LearnMore = styled(motion.div)`
  opacity: 0;
  transform: translateY(10px);
  transition: all 0.3s ease;
  margin-top: 20px;
`;

const LearnMoreLink = styled.a`
  color: var(--theme-accent);
  text-decoration: none;
  font-weight: 600;
  font-size: 1rem;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;

  &:hover {
    color: var(--theme-accent-strong);
    gap: 12px;
  }
`;

const StatsSection = styled(motion.section)`
  margin-top: 80px;
  padding: 60px 40px;
  background: linear-gradient(135deg, var(--theme-hero-start) 0%, var(--theme-hero-end) 100%);
  border-radius: 24px;
  color: white;
  text-align: center;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23ffffff' fill-opacity='0.03'%3E%3Cpath d='m0 40l40-40h-40v40zm40 0v-40h-40l40 40z'/%3E%3C/g%3E%3C/svg%3E");
  }

  @media (max-width: 768px) {
    padding: 40px 20px;
    margin-top: 60px;
  }
`;

const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 50px;
  margin-top: 40px;
  position: relative;
  z-index: 2;

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 40px;
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    gap: 35px;
  }
`;

const StatItem = styled(motion.div)`
  text-align: center;
  
  .stat-number {
    font-size: 3.5rem;
    font-weight: 800;
    color: #FFC857;
    margin-bottom: 10px;
    display: block;
    line-height: 1;
  }
  
  .stat-label {
    font-size: 1.2rem;
    color: rgba(255, 255, 255, 0.9);
    font-weight: 500;
  }
`;

const CTAButton = styled(motion.a)`
  background: linear-gradient(135deg, #FFC857, #FF9F1C);
  color: var(--theme-primary);
  padding: 1.2rem 3rem;
  border-radius: 50px;
  text-decoration: none;
  font-weight: 700;
  font-size: 1.1rem;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 
    0 8px 25px rgba(255, 200, 87, 0.3),
    inset 0 1px 0 rgba(255,255,255,0.3);
  position: relative;
  overflow: hidden;
  display: inline-flex;
  align-items: center;
  gap: 1rem;
  margin-top: 50px;
  letter-spacing: 0.5px;
  border: none;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent);
    transition: left 0.6s ease;
  }
  
  &:hover {
    transform: translateY(-3px);
    box-shadow: 
      0 12px 30px rgba(255, 200, 87, 0.4),
      inset 0 1px 0 rgba(255,255,255,0.3);
    
    &::before {
      left: 100%;
    }
  }

  @media (max-width: 480px) {
    padding: 1rem 2.5rem;
    font-size: 1rem;
    margin-top: 40px;
  }
`;

const ProcessSection = styled(motion.section)`
  margin-top: 80px;
  padding: 60px 40px;
  background: #ffffff;
  border-radius: 24px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
  text-align: center;

  @media (max-width: 768px) {
    padding: 40px 20px;
    margin-top: 60px;
  }
`;

const SectionTitle = styled.h2`
  font-size: clamp(2rem, 4vw, 3rem);
  color: var(--theme-primary);
  margin-bottom: 50px;
  position: relative;
  font-weight: 800;
  letter-spacing: -0.02em;
  
  &::after {
    content: '';
    position: absolute;
    bottom: -20px;
    left: 50%;
    transform: translateX(-50%);
    width: 80px;
    height: 4px;
    background: linear-gradient(to right, var(--theme-primary), var(--theme-accent));
    border-radius: 2px;
  }
`;

const ProcessGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 40px;
  margin-top: 40px;

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    gap: 25px;
  }
`;

const ProcessStep = styled(motion.div)`
  text-align: center;
  padding: 30px 25px;
  background: #f8fafc;
  border-radius: 16px;
  transition: all 0.3s ease;

  &:hover {
    background: #ffffff;
    transform: translateY(-5px);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  }

  @media (max-width: 480px) {
    padding: 25px 20px;
  }
`;

const StepNumber = styled.div`
  width: 60px;
  height: 60px;
  background: var(--theme-accent);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  font-weight: 800;
  margin: 0 auto 20px;
`;

const StepTitle = styled.h3`
  color: var(--theme-primary);
  margin-bottom: 15px;
  font-size: 1.3rem;
  font-weight: 600;
`;

const StepDescription = styled.p`
  color: #64748b;
  line-height: 1.6;
  font-size: 1rem;
`;

const Services = () => {
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.2
            }
        }
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.6,
                ease: "easeOut"
            }
        }
    };

    const services = [
        {
            icon: <FaLaptopCode />,
            title: "Custom Software Development",
            description: "Tailored software solutions designed to meet your specific business needs and challenges. We build scalable applications that drive efficiency and growth.",
            link: "/services/software-development"
        },
        {
            icon: <FaGlobe />,
            title: "Web Development",
            description: "Modern, responsive websites that engage users and drive business growth. We create digital experiences that convert visitors into customers.",
            link: "/services/web-development"
        },
        {
            icon: <FaMobileAlt />,
            title: "Mobile App Development",
            description: "Native and cross-platform mobile applications for iOS and Android. Reach your customers wherever they are with intuitive mobile experiences.",
            link: "/services/mobile-development"
        },
        {
            icon: <FaCloud />,
            title: "Cloud Solutions",
            description: "Scalable cloud infrastructure and services to power your digital transformation. Optimize costs while ensuring reliability and security.",
            link: "/services/cloud-solutions"
        },
        {
            icon: <FaSync />,
            title: "Digital Transformation",
            description: "Comprehensive strategies to modernize your business processes and operations. Embrace innovation and stay ahead of the competition.",
            link: "/services/digital-transformation"
        },
        {
            icon: <FaShieldAlt />,
            title: "IT Security",
            description: "Robust security solutions to protect your data and systems from threats. Implement multi-layered security for complete peace of mind.",
            link: "/services/it-security"
        }
    ];

    return (
        <PageContainer>
            <HeroSection
                variants={containerVariants}
                initial="hidden"
                animate="visible"
            >
                <Title variants={itemVariants}>
                    Our Services
                    <span>Comprehensive IT Solutions</span>
                </Title>
                <Subtitle variants={itemVariants}>
                    We offer a comprehensive range of IT services to help your business
                    thrive in the digital age. From custom software to cloud solutions,
                    we've got you covered.
                </Subtitle>
            </HeroSection>

            <ServicesGrid
                variants={containerVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
            >
                {services.map((service, index) => (
                    <ServiceCard
                        key={index}
                        variants={itemVariants}
                        whileHover={{ y: -5 }}
                        transition={{ delay: index * 0.1 }}
                    >
                        <ServiceIcon className="service-icon">
                            {service.icon}
                        </ServiceIcon>
                        <ServiceTitle>{service.title}</ServiceTitle>
                        <ServiceDescription>{service.description}</ServiceDescription>
                        <LearnMore className="learn-more">
                            <LearnMoreLink href={service.link}>
                                Learn More
                                <FaRocket size={14} />
                            </LearnMoreLink>
                        </LearnMore>
                    </ServiceCard>
                ))}
            </ServicesGrid>

            <StatsSection
                variants={containerVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
            >
                <SectionTitle style={{ color: 'white' }} variants={itemVariants}>
                    Why Choose Our Services?
                </SectionTitle>
                <StatsGrid>
                    <StatItem variants={itemVariants}>
                        <span className="stat-number">500+</span>
                        <div className="stat-label">Projects Completed</div>
                    </StatItem>
                    <StatItem variants={itemVariants}>
                        <span className="stat-number">98%</span>
                        <div className="stat-label">Client Satisfaction</div>
                    </StatItem>
                    <StatItem variants={itemVariants}>
                        <span className="stat-number">50+</span>
                        <div className="stat-label">Expert Team Members</div>
                    </StatItem>
                    <StatItem variants={itemVariants}>
                        <span className="stat-number">24/7</span>
                        <div className="stat-label">Support Available</div>
                    </StatItem>
                </StatsGrid>
                
                <CTAButton 
                    href="/contact"
                    variants={itemVariants}
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                >
                    Start Your Project
                    <FaRocket />
                </CTAButton>
            </StatsSection>

            <ProcessSection
                variants={containerVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
            >
                <SectionTitle variants={itemVariants}>
                    Our Service Process
                </SectionTitle>
                <ProcessGrid>
                    <ProcessStep variants={itemVariants}>
                        <StepNumber>1</StepNumber>
                        <StepTitle>Discovery & Analysis</StepTitle>
                        <StepDescription>
                            We deeply understand your business needs, challenges, and goals to create the perfect solution.
                        </StepDescription>
                    </ProcessStep>
                    <ProcessStep variants={itemVariants}>
                        <StepNumber>2</StepNumber>
                        <StepTitle>Planning & Strategy</StepTitle>
                        <StepDescription>
                            Detailed project planning with clear milestones, timelines, and deliverables.
                        </StepDescription>
                    </ProcessStep>
                    <ProcessStep variants={itemVariants}>
                        <StepNumber>3</StepNumber>
                        <StepTitle>Development & Testing</StepTitle>
                        <StepDescription>
                            Agile development process with continuous testing and quality assurance.
                        </StepDescription>
                    </ProcessStep>
                    <ProcessStep variants={itemVariants}>
                        <StepNumber>4</StepNumber>
                        <StepTitle>Deployment & Support</StepTitle>
                        <StepDescription>
                            Smooth deployment and ongoing support to ensure long-term success.
                        </StepDescription>
                    </ProcessStep>
                </ProcessGrid>
            </ProcessSection>
        </PageContainer>
    );
};

export default Services;
